import { defineStore } from "pinia";
import { ref } from "vue";
import { useFeatureFlag } from "#imports";
export function createFeatureFlagsStore(feats = [], storeName = "feature-flags") {
  return defineStore(storeName, () => {
    const { fetchFeatureFlags } = useFeatureFlag();
    const features = ref({});
    const hasBeenLoaded = ref(feats.length === 0);
    async function loadFeatureFlags() {
      if (hasBeenLoaded.value) {
        return;
      }
      const ff = await fetchFeatureFlags(feats);
      features.value = ff;
      hasBeenLoaded.value = true;
    }
    return {
      loadFeatureFlags,
      features,
      hasBeenLoaded
    };
  });
}
